import { createContext, useContext, useMemo } from "react";
import { IManageRequestService } from "../services/ManageRequestService";
import { createManageRequestService } from "./Bootstrap";
import { useHttpRequestService } from "./HttpRequestContext";

const ManageRequestContext = createContext<IManageRequestService | null>(null);

export const ManageRequestProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const httpRequestService = useHttpRequestService();
    const manageRequestService = useMemo(() => createManageRequestService(httpRequestService), [httpRequestService]);

    return (
        <ManageRequestContext.Provider value={manageRequestService}>
            {children}
        </ManageRequestContext.Provider>
    );
};

export const useManageRequestService = () => {
    const manageRequestService = useContext(ManageRequestContext);
    if (!manageRequestService) {
        throw new Error('useManageRequestService must be used within a ManageRequestProvider');
    }
    return manageRequestService;
};
